import { render } from "./TopColllections.vue?vue&type=template&id=6824e79a"
import script from "./TopColllections.vue?vue&type=script&lang=js"
export * from "./TopColllections.vue?vue&type=script&lang=js"

import "./TopColllections.vue?vue&type=style&index=0&id=6824e79a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__